import { apiErrorToToast } from "@/lib/utils";
import { updateCompanyInfo } from "@/requests/companies/update-company-info.request";
import { ApiErrorResponse } from "@/types/apis";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";

export const useUpdateCompanyInfo = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateCompanyInfo,
    onError: (error: AxiosError<ApiErrorResponse>) => {
      apiErrorToToast(error);
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["companies", variables.companyId],
      });
    },
  });
};
